<div class="flex flex-col min-h-screen overflow-hidden">
  <div class="flex flex-col">
    <div class="flex justify-start mt-0">
      <div class="flex items-center gap-3">
        @if (warehouses$ | async; as warehouses) {
          <select
            (change)="changeWarehouse($event)"
            name="warehouseSelector"
            class="px-2 py-2 text-base font-semibold bg-gradient-to-r from-blue-100 to-blue-200 text-black rounded-xl border border-blue-300 shadow-md focus:outline-none"
            title="Select Warehouse"
          >
            <option disabled selected>Select Warehouse</option>
            @for (house of warehouses; track $index) {
              <option
                [value]="house?.uniqueId"
                [selected]="house.uniqueId == warehouseId"
              >
                {{ house?.name }}
              </option>
            }
          </select>
        }
      </div>
    </div>
  </div>

  <div
    class="grid gap-3 grid-cols-[repeat(auto-fill,minmax(200px,220px))] w-full mt-5"
  >
    <!-- Forecast Card -->
    <div *ngIf="warehouseForecastData?.length > 0">
      <div
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-green-100 to-green-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-green-700 text-xl"
        >
          <mat-icon class="material-symbols-outlined text-xl">cloud</mat-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-sm font-medium text-gray-700">Forecast</span>
          <span class="text-lg font-bold">{{
            warehouseForecastData.slice(-1)[0]?.predicted_time_name
          }}</span>
          <div class="flex flex-wrap justify-end gap-x-2 text-xs text-gray-600">
            <span
              >{{
                warehouseForecastData.slice(-1)[0]?.predicted_humidity
                  | number: "1.0-0"
              }}% Hum.</span
            >
            <span
              >{{
                warehouseForecastData.slice(-1)[0]?.predicted_temperature
                  | number: "1.0-0"
              }}°C Temp.</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Alerts Today Card -->
    <div>
      <div
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-red-100 to-red-200 cursor-pointer"
        (click)="cardClicked('alert', 'TODAY')"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-red-600 text-xl"
        >
          <fa-icon [icon]="faBell"></fa-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-3xl font-bold text-black">{{
            dashboardCardData?.ALERTS?.TODAY_ALERTS
          }}</span>
          <span class="text-sm text-gray-600">Alerts Today</span>
        </div>
      </div>
    </div>

    <!-- Coverage Card -->
    <div *ngIf="coverageData">
      <div
        (click)="cardClicked('coverage')"
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-yellow-100 to-yellow-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-yellow-700 text-xl"
        >
          <mat-icon>grid_view</mat-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-3xl font-bold text-black">
            {{ coverageData?.coverage_ratio }}
          </span>
          <span class="text-sm text-gray-600"> Coverage </span>
          <span class="text-xs text-gray-500">
            {{ coverageData?.warehouse_size }}
          </span>
          <span class="text-xs" [ngClass]="coverageData?.is_fully_covered ? 'text-green-600' : 'text-red-500'">
            {{ coverageData?.coverage_status }}
          </span>
        </div>
      </div>
    </div>

    <!-- Temperature Stability Card -->
    <div>
      <div
        (click)="cardClicked('temperature')"
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-orange-100 to-orange-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-orange-700 text-xl"
        >
          <fa-icon [icon]="faTemperature0"></fa-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-xl font-bold text-black">
            {{
              stabilityReadings?.length > 0
                ? stabilityReadings[0]?.temperature_stability + "%"
                : "No data"
            }}
          </span>
          <span class="text-sm text-gray-600">Temperature Stability</span>
        </div>
      </div>
    </div>

    <!-- Humidity Stability Card -->
    <div>
      <div
        (click)="cardClicked('humidity')"
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-teal-100 to-teal-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-teal-700 text-xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 2.25c-2.25 3-6.75 8.25-6.75 12a6.75 6.75 0 0013.5 0c0-3.75-4.5-9-6.75-12z"
            />
          </svg>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-xl font-bold text-black">
            {{
              stabilityReadings?.length > 0
                ? stabilityReadings[0]?.humidity_stability + "%"
                : "No data"
            }}
          </span>
          <span class="text-sm text-gray-600">Humidity Stability</span>
        </div>
      </div>
    </div>

    <!-- Cold Room Temperature Stability Card -->
    <div>
      <div
        (click)="cardClicked('coldroom-temperature')"
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-cyan-100 to-cyan-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-cyan-700 text-xl"
        >
          <fa-icon [icon]="faTemperatureEmpty"></fa-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-xl font-bold text-black">
            {{
              coldRoomStabilityReadings?.length > 0
                ? coldRoomStabilityReadings[0]?.temperature_stability + "%"
                : "No data"
            }}
          </span>
          <span class="text-sm text-gray-600">Cold Room Temp. Stability</span>
        </div>
      </div>
    </div>

    <!-- Cold Room Humidity Stability Card -->
    <div>
      <div
        (click)="cardClicked('coldroom-humidity')"
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-sky-100 to-sky-200 cursor-pointer"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-sky-700 text-xl"
        >
          <fa-icon [icon]="faDroplet"></fa-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-xl font-bold text-black">
            {{
              coldRoomStabilityReadings?.length > 0
                ? coldRoomStabilityReadings[0]?.humidity_stability + "%"
                : "No data"
            }}
          </span>
          <span class="text-sm text-gray-600">Cold Room Hum. Stability</span>
        </div>
      </div>
    </div>

    <!-- Zones Card -->
    <div>
      <div
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex items-center justify-between gap-3 px-6 py-4 bg-gradient-to-r from-blue-100 to-blue-200 cursor-pointer"
        (click)="cardClicked('zone')"
      >
        <!-- Icon -->
        <div
          class="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-blue-700 text-xl"
        >
          <fa-icon [icon]="faBuilding"></fa-icon>
        </div>

        <!-- Text -->
        <div class="flex flex-col text-right min-w-0">
          <span class="text-3xl font-bold text-black">{{
            dashboardCardData?.ZONES
          }}</span>
          <span class="text-sm text-gray-600">Zone(s)</span>
        </div>
      </div>
    </div>

    <!-- Sensors Card -->
    <div>
      <div
        class="h-full min-h-[112px] w-full rounded-xl shadow-sm flex flex-col justify-between px-6 py-4 bg-gradient-to-r from-purple-100 to-purple-200 cursor-pointer"
        (click)="cardClicked('sensor')"
      >
        <!-- Top section -->
        <div class="flex items-center justify-between">
          <!-- Icon -->
          <div
            class="flex items-center justify-center h-12 w-12 rounded-full bg-white/20 text-purple-700 text-xl"
          >
            <fa-icon [icon]="faThermometer" class="h-6 w-6"></fa-icon>
          </div>

          <!-- Text -->
          <div class="flex flex-col text-right">
            <span class="text-3xl font-bold text-black">{{
              dashboardCardData?.SENSORS?.TOTAL || 0
            }}</span>
            <span class="text-sm text-gray-600">Sensors</span>
          </div>
        </div>

        <!-- Bottom section with Active/Inactive -->
        <div class="grid grid-cols-2 gap-3 mt-4">
          <!-- Active -->
          <div
            class="flex flex-col items-center h-15 bg-white/40 rounded-lg shadow-sm"
          >
            <span class="text-lg font-bold text-green-600">
              {{ dashboardCardData?.SENSORS?.ACTIVE || 0 }}
            </span>
            <span class="text-xs text-gray-700">Active</span>
          </div>

          <!-- Inactive -->
          <div
            class="flex flex-col items-center h-15 justify-center bg-white/40 rounded-lg shadow-sm"
          >
            <span class="text-lg font-bold text-red-600">
              {{ dashboardCardData?.SENSORS?.INACTIVE || 0 }}
            </span>
            <span class="text-xs text-gray-700">Inactive</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-wrap gap-5 justify-center items-start mt-5">
    <div
      class="grid gap-5 w-full grid-cols-1 md:grid-cols-[25%_50%_25%] xl:grid-cols-[20%_60%_20%]"
    >
      <div class="flex flex-col gap-5 h-full">
        <div class="flex flex-col gap-5 flex-1">
          <div
            class="p-4 rounded-xl shadow-lg flex flex-col flex-1 min-h-[160px]"
          >
            <span class="font-bold">Real Time Average Temperature</span>
            <div class="grid w-full h-full">
              <div
                class="relative bg-red-50 text-4xl rounded-lg text-red-500 p-2 font-bold w-full h-full flex items-center justify-center"
              >
                <fa-icon [icon]="faTemperature4"></fa-icon>
                {{
                  dashboardRealtimeSummary?.AVG_TEMPERATURE | number: "1.2-2"
                }}&deg;C
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-red-400 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dataPulledAt }}
                </span>
              </div>
            </div>
          </div>

          <!-- Real Time Humidity Card -->
          <div
            class="p-4 rounded-xl shadow-lg flex flex-col flex-1 min-h-[160px]"
          >
            <span class="font-bold">Real Time Average Humidity</span>
            <div class="grid w-full h-full">
              <div
                class="relative rounded-lg bg-blue-50 text-4xl text-blue-500 p-2 font-bold w-full h-full flex items-center justify-center"
              >
                <fa-icon [icon]="faDroplet"></fa-icon>
                {{ dashboardRealtimeSummary?.AVG_HUMIDITY | number: "1.2-2" }}%
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-blue-500 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dataPulledAt }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-5">
        <!-- Graph container -->
        <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between mt-5">
            <p class="font-bold text-primary text-md">Temperature and Humidity Readings Visualization</p>
            <div
              class="w-[176px] h-[32px] bg-white rounded-full flex items-center px-1"
            >
              <div class="flex gap-1 w-full p-[2px]">
                @for (tab of lineChartsTabs; track tab) {
                  <div
                    (click)="onTabChange(tab.slug)"
                    [ngClass]="{
                      'bg-primary text-white rounded-full':
                        activeSlugLineCharts === tab.slug,
                      'text-gray-500': activeSlugLineCharts !== tab.slug,
                    }"
                    class="cursor-pointer text-[12px] font-medium px-3 h-[24px] flex items-center justify-center text-center truncate transition-colors duration-200"
                    style="
                      max-width: 80px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ tab.name }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        @if (loadingData === true) {
          <div class="skeleton-wrapper">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ height: '350px', width: '100%' }"
            ></ngx-skeleton-loader>
          </div>
        } @else {
          <div class="chart-container w-full min-h-[350px] md:min-h-[450px]">
            <!-- Filter container -->
            <div class="filter-containerBig">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div class="time-container">
                  <span>From</span>
                  <input
                    type="datetime-local"
                    [(ngModel)]="sixHoursPast"
                    [max]="currentTime"
                    (change)="onTimeChange()"
                    class="date-input"
                  />
                </div>
                <div class="time-container">
                  <span>To</span>
                  <input
                    type="datetime-local"
                    [(ngModel)]="currentTime"
                    [min]="sixHoursPast"
                    (change)="onTimeChange()"
                    class="date-input"
                  />
                </div>
              </div>

              <button
                matTooltip="Click to toggle live graph"
                (click)="setFetchStatus()"
                class="live-button"
              >
                <span
                  class="status-dot"
                  [ngClass]="{
                    'pulse-button': fetchStatus === 'live',
                    'pulse-not-live': fetchStatus === 'fixed',
                  }"
                ></span>
                <span>Live</span>
              </button>
            </div>

            <!-- Chart -->
            @if (activeSlugLineCharts === "lineChartsTemp") {
              <app-bar-graph
                *ngIf="showChart"
                title="Temperature"
                [data]="tempLineChartsData"
                [width]="'100%'"
                [height]="520"
                [gridX]="false"
                [horizontal]="false"
                [gridY]="true"
                [xAxis]="xAxis"
                [showXlabel]="true"
                [showYlabel]="true"
                columnWidth="25%"
                chart_type="area"
                LegendPosition="top"
                horizontalAlign="right"
              ></app-bar-graph>
            } @else {
              <app-bar-graph
                *ngIf="showChart"
                title="Humidity"
                [data]="humLineChartsData"
                [width]="'100%'"
                [height]="520"
                [gridX]="false"
                [horizontal]="false"
                [gridY]="true"
                [xAxis]="xAxis"
                [showXlabel]="true"
                [showYlabel]="true"
                columnWidth="25%"
                chart_type="area"
                LegendPosition="top"
                horizontalAlign="right"
              ></app-bar-graph>
            }
          </div>
        }
      </div>

      <!-- Right Column -->
      <div class="flex flex-col gap-5 h-full">
        <div class="flex flex-col gap-5 flex-1">
          <!-- Temperature Summary -->
          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"> </span>

            <div class="grid grid-rows-2 gap-2 h-full">
              <!-- Highest -->
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature4"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Highest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MAX_TEMPERATURE | number: "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>

              <!-- Lowest -->
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature0"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MIN_TEMPERATURE | number: "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>

                  {{ dashboardData?.SUMMARY?.MIN_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>

          <!-- Humidity Summary -->
          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"></span>

            <div class="grid grid-rows-2 gap-2 h-full">
              <!-- Highest -->
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature4"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Highest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY | number: "1.2-2" }}%
                </p>
                <p class="text-[10px] text-blue-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY_TIMESTAMP }}
                </p>
              </div>

              <!-- Lowest -->
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature0"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY | number: "1.2-2" }}%
                </p>
                <p class="text-[10px] text-[#4dc3dd] uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Warehouse Heatmap -->
  <div class="mt-6">
    <app-warehouse-heatmap [warehouseId]="warehouseId"></app-warehouse-heatmap>
  </div>

  <div class="grid grid-cols-12">
    <div class="col-span-12 md:col-span-12 flex flex-col gap-5">
      <div class="flex items-center justify-between gap-6 mt-2 w-full">
        <p style="color: rgb(26, 25, 25); font-weight: 800"></p>

        <div class="flex items-center justify-end gap-4 mt-6">
          <div class="flex items-center">
            <div
              class="flex items-center bg-white text-gray-500 rounded-full pl-2 h-10 shadow gap-3"
            >
              <span class="font-medium">
                {{
                  activeSlugzonesList === "zonesList"
                    ? "Add Zone"
                    : "Add Sensor"
                }}
              </span>

              <button
                class="flex items-center justify-center w-10 h-10 bg-[#025590] rounded-full text-white"
                (click)="onAdd()"
              >
                <img
                  src="assets/images/add-circle-half-dot.png"
                  alt="add"
                  class="h-5 w-5"
                />
              </button>
            </div>
          </div>

          <!-- Toggle Container -->
          <div
            class="w-auto h-[42px] bg-white rounded-full flex items-center px-1 shadow-sm"
          >
            <div class="flex gap-1 w-full">
              @for (tab of listTabs; track tab) {
                <div
                  (click)="onListTabChange(tab.slug)"
                  [ngClass]="{
                    'bg-primary-50 text-primary-600 rounded-full':
                      activeSlugzonesList === tab.slug,
                    'text-gray-500': activeSlugzonesList !== tab.slug,
                  }"
                  class="cursor-pointer text-[12px] font-medium px-3 h-[34px] flex items-center justify-center truncate transition-colors duration-200"
                  style="
                    max-width: 90px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ tab.name }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-8 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xlg:grid-cols-2 gap-10"
      >
        <!-- Left column: sensors carousel -->
        <div class="bg-white rounded-lg shadow p-4 flex flex-col h-[450px]">
          <span class="font-bold text-gray-700 flex items-center gap-3 mb-4">
            <fa-icon [icon]="faThermometer"></fa-icon>
            Sensors
          </span>
          <div class="flex-1 overflow-hidden">
            <app-carousel
              [items]="items"
              class="h-full [&_img]:max-h-[350px] w-[400px][&_img]:object-contain [&_img]:mx-auto"
            >
            </app-carousel>
          </div>
        </div>
        <div class="h-[450px] bg-white rounded-lg shadow p-4 flex flex-col">
          <div class="flex-1 overflow-y-auto">
            @if (activeSlugzonesList === "sensorsList") {
              <app-warehouse-sensor-list
                *ngIf="activeSlugzonesList === 'sensorsList'"
                [sensors]="filteredSensors"
                [refresh]="refreshTable"
                class="w-full"
              ></app-warehouse-sensor-list>
            } @else if (activeSlugzonesList === "zonesList") {
              <app-warehouse-zone-list
                *ngIf="activeSlugzonesList === 'zonesList'"
                [zones]="filteredZones"
                [refresh]="refreshTable"
                class="w-full"
              ></app-warehouse-zone-list>
            } @else {
              <app-warehouse-assignee-list
                [refresh]="refreshTable"
                class="w-full"
              ></app-warehouse-assignee-list>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div></div>
</div>
